import { useState } from 'react';
import { X } from 'lucide-react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  wtRequestId: number | null;
  airexOrderId?: string;
}

export default function ConfirmCancelWidget({ isOpen, onClose, onConfirm, wtRequestId, airexOrderId }: Props) {
  const [loading, setLoading] = useState(false);
  if (!isOpen || !wtRequestId) return null;

  const handleConfirm = async () => {
    if (loading) return;
    setLoading(true);
    try {
      await Promise.resolve(onConfirm());
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 dark:bg-black/70 backdrop-blur-sm flex items-center justify-center z-[210]">
      <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 max-w-md w-full mx-4 border border-gray-200 dark:border-gray-700 shadow-2xl">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 rounded-lg bg-red-100 dark:bg-red-900/30">
            <X className="w-6 h-6 text-red-600 dark:text-red-400" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Отмена заявки</h3>
        </div>
        <p className="text-gray-700 dark:text-gray-300 mb-5">
          Отменить WT-заявку <strong>#{wtRequestId}</strong>
          {airexOrderId && <> (#{airexOrderId})</>} и связанный мэтч?
        </p>
        <div className="flex gap-3">
          <button
            onClick={handleConfirm}
            disabled={loading}
            className="flex-1 bg-red-600 hover:bg-red-700 text-white py-2.5 px-4 rounded-xl disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:bg-red-600"
          >
            {loading ? 'Отмена…' : 'Да, отменить'}
          </button>
          <button onClick={onClose} className="flex-1 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 py-2.5 px-4 rounded-xl text-gray-800 dark:text-gray-200">
            Нет
          </button>
        </div>
      </div>
    </div>
  );
}
